module.exports = __webpack_public_path__ + "static/bg1-298c5f2cc52142654118c17592918864.png";